<template>
  <div class="min-h-screen pb-8 bg-gray-100 font-live">

    <testmode-ribbon :session="session"></testmode-ribbon>

    <nav class="bg-white top-0 left-0 shadow-sm fixed w-full">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-12 sm:h-16">
          <div class="flex">
            <div class="flex-shrink-0 flex items-center">
              <img class="block sm:hidden h-8 sm:h-10 w-auto sharp-image" src="/img/brandpreneurship-logo.png"
                alt="brandpreneurship" />
              <img class="hidden sm:block h-8 sm:h-10 w-auto sharp-image" src="/img/brandpreneurship-logo.png"
                alt="brandpreneurship" />
            </div>
            <div v-if="false" class="ml-6 flex-col sm:mt-1">
              <p class="text-lg sm:text-xl font-light">
                brandpreneurship
              </p>
            </div>

          </div>

          <div class="ml-6 flex float-right items-center space-x-4">
            
          </div>
        </div>
      </div>
    </nav>

    <div class="py-1">
      <main>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 pt-12">
          <!-- Main: start -->

          <slot></slot>

          <!-- Main: end -->
        </div>
      </main>
    </div>


    <section class="fixed bottom-0 left-0 w-full text-center bg-white shadow-sm">
      <slot name="footer"></slot>
    </section>
  </div>
</template>

<script>
import TestmodeRibbon from '@/Shared/TestmodeRibbon';

export default {
  components: {
    TestmodeRibbon,
  },

  props: ['session'],
}
</script>